import type { MRT_ColumnDef } from "mantine-react-table-open";
import {
  MantineNullCell,
  renderNullableCell
} from "../../../../../mantine/mrt/components/cell/MantineNullCell";
import { getDateColumn } from "../../../../../mantine/mrt/components/columns/getDateColumn";
import { GeneratorTypeLabel } from "../../../../../utils/backend-types";
import { ObjectName } from "../../../../../utils/enums";
import { InstalledCapacityCell } from "../../../../ComponentListContainer/ComponentList/columns/getCustomColumns";
import { getGeneratorRedispatchColumn } from "../../../../ComponentListContainer/ComponentList/columns/getGeneratorRedispatchColum";
import { ComponentOpenEditModalLink } from "../../../../ComponentListContainer/ComponentOpenEditModalLink/ComponentOpenEditModalLink";
import type { GeneratorListItemResponse } from "../../../../ObjectModals/GeneratorModal/GeneratorModal.types";

interface GetAllgemeineDatenColumnsProps {
  projectId: string;
  siteId: number;
}

export function getAllgemeineDatenColumns({
  projectId,
  siteId
}: GetAllgemeineDatenColumnsProps): Array<
  MRT_ColumnDef<GeneratorListItemResponse>
> {
  return [
    getGeneratorRedispatchColumn<GeneratorListItemResponse>({
      generatorIdFieldName: "id",
      siteId
    }),
    {
      id: "einheit_mastr_nummer",
      header: "MaStR-Nummer",
      accessorFn: (row) => row.einheit_mastr_nummer,
      Cell: renderNullableCell
    },
    {
      header: "Betreiber",
      accessorKey: "person",
      enableCellHoverReveal: true,
      Cell: ({ cell, row }) => {
        const person = row.original.person_id;
        return (
          person && (
            <ComponentOpenEditModalLink
              componentId={person}
              linkContent={cell.getValue<string | number>()}
              objectName={ObjectName.Person}
              projectId={projectId}
              siteId={siteId}
            />
          )
        );
      }
    },
    {
      header: "Typ",
      id: "type",
      size: 120,
      accessorFn: (row) => (row.type ? GeneratorTypeLabel[row.type] : undefined)
    },
    {
      header: "Nettonennleistung",
      accessorKey: "installed_capacity",
      Cell: ({ cell }) => (
        <InstalledCapacityCell
          value={
            cell.getValue<GeneratorListItemResponse["installed_capacity"]>() ??
            null
          }
        />
      )
    },
    getDateColumn<GeneratorListItemResponse>({
      key: "commissioning",
      options: {
        header: "Inbetriebnahme"
      },
      renderUndefinedAs: <MantineNullCell />
    }),
    getDateColumn<GeneratorListItemResponse>({
      key: "decommissioning",
      options: {
        header: "Außerbetriebnahme"
      },
      renderUndefinedAs: <MantineNullCell />
    }),
    {
      header: "SR-ID",
      accessorKey: "sr_id",
      Cell: renderNullableCell
    },
    {
      header: "TR-ID",
      accessorKey: "tr_id",
      Cell: renderNullableCell
    }
  ];
}
